<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     资料库
  +---------------------------------------------------------------------------------------
-->
<template>
  <div class="electronic-database-list">
    <div class="filter-container">
      <div class="filter-box">
        <div class="filter-item" style="width: 160px;">
          <el-input v-model="query.keyword" placeholder="资料名称" prefix-icon="el-icon-search" clearable @change="fetchData(1)" />
        </div>
      </div>

      <div class="toolbox">
        <el-button icon="el-icon-upload2" type="success" @click="handleUpload()">上传资料</el-button>
        <f-sort-selector v-model="query.sort" :options="sortOptions" class="ml-sm" @change="fetchData(1)" />
      </div>
    </div>

    <el-card shadow="never" class="mb-md">
      <el-table ref="listTable" v-loading="loading" :data="list" style="width: 100%">
        <el-table-column type="index" label="#" width="80" align="center" />

        <el-table-column label="名称" width="60">
          <template slot-scope="scope">
            <div class="flex align-items-center">
              <el-image class="image" :src="scope.row.qrcode_url" fit="cover" :preview-src-list="[scope.row.qrcode_url]"></el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column min-width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-link :underline="false" class="" @click="browse(scope.row)">{{ scope.row.title }}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="大小" min-width="80" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.file_size | byteSize }}</template>
        </el-table-column>
        <el-table-column label="生效范围" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.row.effect_scope == 1" class="flex align-items-center">
              <el-tag type="info">{{ '不指定设备' }}</el-tag>
            </div>
            <div v-else-if="scope.row.effect_scope == 2" class="flex align-items-center">
              <el-tag type="info">{{ '所有设备' }}</el-tag>
            </div>
            <div v-else-if="scope.row.effect_scope == 3 && scope.row.devs && scope.row.devs.length" class="flex align-items-center">

              <span v-for="dev in scope.row.devs" :key="dev.devid">
                <el-tag type="info" class="mr-sm">{{ dev.dev_name }}</el-tag>
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="查看权限" min-width="80">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.auth_level" type="success">{{ authObj[scope.row.auth_level].title }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="允许分享" min-width="80">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.is_allow_share"
              active-color="#07c160"
              :active-value="1"
              :inactive-value="0"
              @change="handleShare(scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column label="允许下载" min-width="80">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.is_allow_download"
              active-color="#07c160"
              :active-value="1"
              :inactive-value="0"
              @change="handleDownload(scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column label="创建时间" min-width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.createtime | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="browse(scope.row)">浏览</el-button>
            <el-dropdown trigger="click" placement="bottom-start" class="ml-sm">
              <el-button type="text">更多</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="handleEdit(scope.row)">编辑</el-dropdown-item>
                <el-dropdown-item @click.native="handleDelete(scope.row)">删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
        <template slot="append">
          <f-table-footer>
            <template slot="right">
              <f-pagination :total="total" :pindex.sync="query.pindex" :psize.sync="query.psize" @change="fetchData" />
            </template>
          </f-table-footer>
        </template>
        <template slot="empty">
          <div class="font-md mt-hg">暂无数据</div>
        </template>
      </el-table>
    </el-card>

    <upload-resource v-if="upload_show" :show.sync="upload_show" :edit="edit" :resource="current_resource" @change="fetchData(1)" />
  </div>
</template>

<script>
import {
  getResourceListApi,
  resourceUpdateApi,
  resourceDeleteApi,
} from "@/api/fam/famGodApi";

export default {
  name: "FamResource",

  components: {
    UploadResource: () => import("./components/UploadResource"),
  },

  data() {
    return {
      list: [],
      total: 0,
      loading: false,
      query: {
        sort: 1,
        pindex: 1,
        psize: this.$store.state.commonStore.psize,
        keyword: "",
      },
      sortOptions: [
        { value: 1, title: "最近创建" },
        { value: 2, title: "最早创建" },
      ],

      upload_show: false,
      current_resource: null,
      edit: false,
    };
  },

  computed: {
    authObj() {
      return this.$store.getters.authObj
    },
  },

  created() {
    this.fetchData(1, true)
  },

  methods: {
    fetchData(page, loading) {
      if (page) this.query.pindex = page
      if (loading) this.loading = true
      getResourceListApi(this.query).then((res) => {
        this.loading = false;
        if (!res.errno) {
          this.list = res.data.list;
          this.total = res.data.total;
        }
      });
    },

    handleUpload() {
      this.upload_show = true;
      this.edit = false;
    },

    browse(row) {
      window.open(row.url);
    },

    handleShare(row) {
      this.$confirm(
        row.is_allow_share == 1
          ? `此操作将开启分享，是否继续？`
          : `此操作将关闭分享，是否继续？`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          type: "warning",
        }
      )
        .then(() => {
          const temp = {
            resourceid: row.resourceid,
            is_allow_share: row.is_allow_share,
            url: row.url,
            title: row.title,
            effect_scope: row.effect_scope,
            is_allow_download: row.is_allow_download,
            effect_devids: row.effect_devids,
            auth_level: row.auth_level,
          };
          resourceUpdateApi(temp).then((res) => {
            if (!res.errno) {
              this.fetchData();
              this.$message.success("操作成功");
            } else {
              row.is_allow_share = row.is_allow_share == 0 ? 1 : 0;
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          row.is_allow_share = row.is_allow_share == 0 ? 1 : 0;
        });
    },

    handleDownload(row) {
      this.$confirm(
        row.is_allow_download == 1
          ? `此操作将开启下载，是否继续？`
          : `此操作将关闭下载，是否继续？`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          type: "warning",
        }
      )
        .then(() => {
          const temp = {
            resourceid: row.resourceid,
            is_allow_share: row.is_allow_share,
            url: row.url,
            title: row.title,
            effect_scope: row.effect_scope,
            is_allow_download: row.is_allow_download,
            effect_devids: row.effect_devids,
            auth_level: row.auth_level,
          };
          resourceUpdateApi(temp).then((res) => {
            if (!res.errno) {
              this.fetchData();
              this.$message.success("操作成功");
            } else {
              row.is_allow_download = row.is_allow_download == 0 ? 1 : 0;
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          row.is_allow_download = row.is_allow_download == 0 ? 1 : 0;
        });
    },

    handleEdit(row) {
      this.current_resource = row;
      this.edit = true;
      this.upload_show = true;
    },

    handleDelete(row) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          resourceDeleteApi({ resourceid: row.resourceid }).then((res) => {
            if (!res.errno) {
              this.fetchData(1);
              this.$message.success("删除成功");
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.electronic-database-list {
  .el-table {
    .name {
      vertical-align: top;
    }
  }
}
</style>
<style lang="scss">
.electronic-database-list {
  .el-link {
    display: revert;
  }
}
</style>
